import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

import getPaymentMethodLink from 'components/Common/Billing/utils/getPaymentMethodLink';
import useW9FormLink from 'components/Common/Billing/Hooks/useW9FormLink';
import { useContext } from 'components/Managers/Billing/Context';

import confirmAlert from 'components/new_ui/Alerts/confirm';
import Alert from 'components/new_ui/Alerts/alert';

import getPaymentMethodInformation from 'components/Common/Billing/utils/getPaymentMethodInformation';

export default function Setup({ paymentMethod }) {
  const { actions, dispatch } = useContext();
  const [loadingSetPaymentLink, setLoadingPaymentLink] = useState(false);
  const { loading: loadingW9FormLink, w9FormLink } = useW9FormLink();

  const paymentInformation = getPaymentMethodInformation(
    paymentMethod === null ? '' : paymentMethod.attributes.payment_method_status,
  );

  const setupPaymentMethod = () => {
    setLoadingPaymentLink(true);
    getPaymentMethodLink({
      paymentInformationId: paymentMethod === null ? null : paymentMethod.id,
    }).then((res) => {
      setLoadingPaymentLink(false);
      actions.addOrUpdatePaymentMethod(dispatch, res.payment_information);
      document.location.href = res.link;
    });
  };

  const downloadW9Form = () => {
    if (w9FormLink) {
      window.open(w9FormLink, '_blank', 'noreferrer');
    }
  };

  const detachPaymentMethod = () => {
    confirmAlert({
      title: 'Confirm Removal',
      text: `Are you sure you want to remove this payment method? This action cannot be undone. 
        Future payments will require a new method.`,
      confirmButtonText: 'Delete',
    }, () => {
      actions.deleteLinkedPaymentMethod(dispatch, paymentMethod.id, (errors) => {
        Alert({
          title: 'Action Required',
          text: errors.map((item) => item.title).join('.'),
        });
      });
    });
  };

  const isPaymentMethodPresent = paymentMethod !== null && paymentMethod.attributes.payment_method_status !== '';
  let className = '';

  switch (paymentInformation.value) {
    case 'succeeded':
      className = 'text-primary';
      break;
    case 'other':
    case '':
      className = 'text-danger';
      break;
    default:
      className = '';
  }

  return (
    <div className="h-100 d-flex flex-column justify-content-center border rounded-5 p-5 text-center">
      <p>
        Payment Method:
        {' '}
        <span className={`fw-semibold ${className}`}>{paymentInformation.label}</span>
      </p>

      <Button
        className="d-block mx-auto"
        disabled={loadingSetPaymentLink}
        onClick={setupPaymentMethod}
      >
        {isPaymentMethodPresent ? 'Change Payment Method' : 'Setup Payment Method'}
      </Button>
      {isPaymentMethodPresent && (
      <Button
        variant="danger"
        className="d-block mx-auto mt-4"
        onClick={detachPaymentMethod}
      >
        Remove Payment Method
      </Button>
      )}

      <div className="mt-2 small fw-light text-muted">
        {paymentInformation.description}
      </div>

      <Button
        variant="outline-primary"
        className="btn-reverse d-block mt-4 mx-auto"
        disabled={loadingW9FormLink}
        onClick={downloadW9Form}
      >
        Download W-9 Form
      </Button>
    </div>
  );
}

Setup.propTypes = {
  paymentMethod: PropTypes.object,
};

Setup.defaultProps = {
  paymentMethod: null,
};
